import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {DropdownMenuButtonComponent} from '../../../dropdown-button';
import {DropdownMenuItem} from '../../../dropdown-menu/dropdown-menu-item';
import {DynWalletDropdownMenuItem} from './dyn-wallet-widget-menu/dyn-wallet-dropdown-menu-item';
import {DynWalletMenuComponent} from './dyn-wallet-widget-menu/dyn-wallet-menu.component';

const SEPARATOR_MENU_ITEM: DropdownMenuItem = {
    label:       '',
    isSeparator: true
};

@Component({
    selector:        'button[dynWalletItems]',
    templateUrl:     '../../../dropdown-button/dropdown-menu-button.component.html',
    styleUrls:       [
        '../../../dropdown-button/dropdown-menu-button.component.scss',
        './dyn-wallet-dropdown-button.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynWalletDropdownButtonComponent extends DropdownMenuButtonComponent {

    @Input('dynWalletItems')
    public override dropdownMenuItems: DropdownMenuItem[];

    @Output()
    public walletClick = new EventEmitter<string>();

    @Output()
    public profileClick = new EventEmitter<void>();

    @Output()
    public logoutClick = new EventEmitter<void>();

    public override isChevronShown = true;

    protected override toggleDropdownMenu(): void {
        if (!this.dropdownMenuComponent) {
            const extendedMenuItems: DynWalletDropdownMenuItem[] = [
                ...this.dropdownMenuItems.map(item => ({
                    ...item,
                    callback: () => this.walletClick.emit(item.value)
                })),
                {
                    label:    'Wallet Profile',
                    icon:     '#main-menu-user-management',
                    callback: () => this.profileClick.emit()
                },
                {
                    label:    'components.main-menu.logout',
                    icon:     '#main-menu-logout',
                    callback: () => this.logoutClick.emit()
                }
            ];

            const separatedDropdownMenuItems: DynWalletDropdownMenuItem[] = extendedMenuItems.reduce((
                result: DropdownMenuItem[],
                dropdownMenuItem: DropdownMenuItem,
                index: number,
                dropdownMenuItems: DropdownMenuItem[]
            ) => {
                index < dropdownMenuItems.length - 1
                    ? result.push(dropdownMenuItem, {...SEPARATOR_MENU_ITEM}) // Copy for tracking in @for
                    : result.push(dropdownMenuItem);

                return result;
            }, []);

            this.dropdownMenuComponent = this.modalService.open(DynWalletMenuComponent, {
                configure: {
                    targetElement: this.buttonElementRef,
                    menuItems: separatedDropdownMenuItems,
                    onCloseCallback: value => this.closeDropdownMenu(value)
                }
            }).instance;
        } else {
            this.closeDropdownMenu();
        }
    }

}
